export default __webpack_public_path__ + "static/media/blog-head.ccef5fe7.png";